/* global __CLIENT__ */
import PropTypes from 'prop-types';

import React from 'react';

const NoElements = ({ missingEntity, missingType, options, dashboard }) => {
  let message;

  switch (missingType) {
    case 'problems':
      message = 'No problems found!';
      break;
    case 'organization': {
      message = (
        <div>
          Welcome to planz! Please contact <a onClick={() => {window.location.href = `mailto:support@planz.dev`}}>support@planz.dev</a> if you are first time user. If your company already uses planz, please contact your planz administrator.
        </div>
      )
      break;
    }
    case 'projects': {
      message = 'You are currently not on any projects.'
      break;
    }
    case 'scores': {
      message = 'No Scoring Data Available.'
      break;
    }
    case 'dashboardReport':
    case 'dashboardActivities':
      message = `No ${missingEntity} Detected.`
      break;
    case 'report':
      if (missingEntity === "baseline") {
        message = 'No baseline exists in this project. Go to project Settings -> Baselines to create one.';
        break;
      }
    case 'activities':
    case 'comments':
    case 'issues':
      message = `No ${missingEntity} detected.`;
      break;
    default:
      message = `The view you’ve selected has no ${missingEntity} associated with it.`;
      break;
  }

  if (dashboard) {
    return (
      <div style={{ display: 'flex', flex: 1, padding: '0.5rem 0.75rem' }}>
        <div style={{
          fontSize: '14px',
          color: '#707070',
          fontWeight: '700',
        }}>
          {message}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      { options && options.ignoreBold ? <div>{message}</div> : <strong>{message}</strong> }
    </div>
  );
};

NoElements.propTypes = {
  missingEntity: PropTypes.string,
  missingType: PropTypes.string,
};

export default NoElements;



// WEBPACK FOOTER //
// ./src/components/states/NoElements.js